export var __useDefault = true; export default "<span class=\"app-store-link-badge-android\"></span>\n";